import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IColumnDescription, GridColumnDescription, FormGroupDescription } from './adapter_t';
import { nameof, TwoWayAdapter, IModelMetadata, From } from '@bds/core';

export class BlPartyIdQualifier implements From<BlPartyIdQualifier> {
    constructor(
        public idQualifier?: string,
        public description?: string,
        public requiredAddressCode?: string,
    ) {}
    from(trip: BlPartyIdQualifier): BlPartyIdQualifier {
        Object.keys(trip).forEach((k) => (this[k] = trip[k]));
        return this;
    }
}

export const relationship: IModelMetadata[] = [
    { client: nameof<BlPartyIdQualifier>('idQualifier'), server: 'idQualifier' },
    { client: nameof<BlPartyIdQualifier>('description'), server: 'description' },
    { client: nameof<BlPartyIdQualifier>('requiredAddressCode'), server: 'requiredAddressCode' },
];

@Injectable({
    providedIn: 'root',
})
export class BlPartyIdQualifierAdapter extends TwoWayAdapter<BlPartyIdQualifier> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}

// https://www.devexpress.com/Support/Center/Question/Details/T746351/datagrid-how-to-set-columns-at-runtime
@Injectable({
    providedIn: 'root',
})
export class BlPartyIdQualifierMetadata implements FormGroupDescription {
    constructor() {}

    getFormGroup(obj?: any): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({});
        formGroup.addControl(
            nameof<BlPartyIdQualifier>('idQualifier'),
            new UntypedFormControl('', [Validators.required, Validators.maxLength(2)]),
        );
        formGroup.addControl(
            nameof<BlPartyIdQualifier>('description'),
            new UntypedFormControl('', [Validators.maxLength(50)]),
        );
        formGroup.addControl(
            nameof<BlPartyIdQualifier>('requiredAddressCode'),
            new UntypedFormControl('', [Validators.maxLength(2)]),
        );

        if (!!obj) {
            formGroup.setValue(obj);
        }
        return formGroup;
    }
}
